import { createContext, useContext } from "react";
import { ScenarioNodeType } from "types/scenario";

type FlowCanvasActions = {
  onAddBranchNode: (choiceKey: string, optionIndex: number, type: ScenarioNodeType) => void;
};

const FlowCanvasContext = createContext<FlowCanvasActions | null>(null);

export const FlowCanvasProvider = FlowCanvasContext.Provider;

export const useFlowCanvasActions = () => {
  const value = useContext(FlowCanvasContext);

  if (!value) {
    throw new Error("useFlowCanvasActions must be used within FlowCanvasProvider");
  }

  return value;
};
